import React, { useState } from "react";
import { Users, Building2, BookOpen, FileText } from "lucide-react";
import { Button } from "./ui/button";
import { UsersTab } from "./admin/UsersTab";
import { SitesTab } from "./admin/SitesTab";
import { StudiesTab } from "./admin/StudiesTab";
import { TemplatesTab } from "./admin/TemplatesTab";

const VIEWS = [
  { key: "users", label: "Users", icon: Users },
  { key: "sites", label: "Sites", icon: Building2 },
  { key: "studies", label: "Studies", icon: BookOpen },
  { key: "templates", label: "Templates", icon: FileText },
];

export const AdminPanel = ({
  users, sites, studies, templates,
  setIsAddUserOpen, setIsAddSiteOpen, setIsAddStudyOpen, setIsAddTemplateOpen,
  openUserEditor, openSiteEditor, openStudyEditor, openTemplateEditor,
  deleteUser, deleteSite, deleteStudy, deleteTemplate,
}) => {
  const [adminView, setAdminView] = useState("users");

  const tabContent = {
    users: <UsersTab users={users} sites={sites} studies={studies} setIsAddUserOpen={setIsAddUserOpen} openUserEditor={openUserEditor} deleteUser={deleteUser} />,
    sites: <SitesTab sites={sites} setIsAddSiteOpen={setIsAddSiteOpen} openSiteEditor={openSiteEditor} deleteSite={deleteSite} />,
    studies: <StudiesTab studies={studies} setIsAddStudyOpen={setIsAddStudyOpen} openStudyEditor={openStudyEditor} deleteStudy={deleteStudy} />,
    templates: <TemplatesTab templates={templates} setIsAddTemplateOpen={setIsAddTemplateOpen} openTemplateEditor={openTemplateEditor} deleteTemplate={deleteTemplate} />,
  };

  return (
    <div data-testid="admin-panel" className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-900">Admin Panel</h1>
        <div className="flex items-center space-x-2 bg-white rounded-lg shadow-sm p-1 border">
          {VIEWS.map(({ key, label, icon: Icon }) => (
            <Button
              key={key}
              variant={adminView === key ? "default" : "ghost"}
              onClick={() => setAdminView(key)}
              className="flex items-center gap-2"
              size="sm"
              data-testid={`admin-tab-${key}`}
            >
              <Icon className="h-4 w-4" /> {label}
            </Button>
          ))}
        </div>
      </div>

      {tabContent[adminView]}
    </div>
  );
};
